import { render, staticRenderFns } from "./DocumentoEstado.vue?vue&type=template&id=0861c39f&scoped=true"
import script from "./DocumentoEstado.vue?vue&type=script&lang=js"
export * from "./DocumentoEstado.vue?vue&type=script&lang=js"
import style0 from "./DocumentoEstado.vue?vue&type=style&index=0&id=0861c39f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0861c39f",
  null
  
)

export default component.exports